import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateOrganizationUrl } from "../../../config";
import api from "../../../api";
import { Status } from "../../../common/constants";
import { RootState } from "../../../store";
import { IInitialSliceState } from "../../../common/types/commonTypes";

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  msg: null,
};

interface IEditResponse {
  message: string;
}

interface IEditBody {
  phoneNo: string;
  address: string;
}

interface IEditPayload {
  orgId: string;
  body: IEditBody;
}

export const editOrgAdmin = createAsyncThunk(
  "editOrgAdmin",
  async (payload: IEditPayload, { rejectWithValue }) => {
    try {
      const response = await api.patch(
        updateOrganizationUrl + `?orgId=${payload.orgId}`,
        payload.body
      );
      const editResponse: IEditResponse = response.data;
      return editResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const editOrgAdminSlice = createSlice({
  name: "editOrgAdmin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(editOrgAdmin.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(editOrgAdmin.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.status = Status.SUCCESS;
      })
      .addCase(editOrgAdmin.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Error occurred while updating";
        state.status = Status.FAILED;
      });
  },
});

export const selector = (state: RootState) => state.editOrganization;

export const reducer = editOrgAdminSlice.reducer;
